import { render, staticRenderFns } from "./TAVlist.vue?vue&type=template&id=60001c6e&scoped=true"
import script from "./TAVlist.vue?vue&type=script&lang=js"
export * from "./TAVlist.vue?vue&type=script&lang=js"
import style0 from "./TAVlist.vue?vue&type=style&index=0&id=60001c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60001c6e",
  null
  
)

export default component.exports